import { START_OPERATION, FINISH_OPERATION, FAIL_OPERATION } from './index';

export default (state = [], action) => {
  switch (action.type) {
    case START_OPERATION:
      return [...state, action.id];

    case FINISH_OPERATION:
    case FAIL_OPERATION:
      return state.filter(item => item !== action.id);

    default:
      return state;
  }
};
